import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AppUnauthorizedComponent } from './shared/components/app-unauthorized.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { DynamicTabsComponent } from './customerservice/components/dynamic-tabs.component';
import { ImpersonationComponent } from './customerservice/components/impersonation.component';
import { EmailWhitelistComponent } from './shared/components/email-whitelist.component';
import { TermsAndConditionComponent } from './customerservice/components/terms-and-condition.component';
import { UploadMediaComponent } from './shared/components/upload-media.component';

const appModuleRoutes: Routes = [
  { path: 'customerservice/search', component: DynamicTabsComponent },
  { path: 'customerservice/unauthorized', component: AppUnauthorizedComponent },
  { path: 'impersonation/:id', component: ImpersonationComponent },
  { path: '', redirectTo: 'customerservice/search', pathMatch: 'full' },
  { path: 'whitelist-email', component: EmailWhitelistComponent },
  { path: 'anonymous-retail-subscription/terms-and-condition',component:TermsAndConditionComponent},
  { path: 'upload-media', component: UploadMediaComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(appModuleRoutes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts